module.exports = __webpack_public_path__ + "static/img/s159.3fe3c4cc.png";